import {
  DeleteConsentsResponse,
  GenerateOtpResponse,
  GetConsentsResponse,
  UpdateConsentsRequest,
  UpdateConsentsResponse,
  VerifyOtpResponse
} from './entity/entity-response';
import PersistenceService from './persistence-service';
import fetchMock from 'fetch-mock';
import {URLS} from '../constant/constant';
import generateOTPMock from '../assets/mock/generateOtp.json';
import verifyOTPMock from '../assets/mock/verifyOtp.json';
import getConsentMock from '../assets/mock/getConsents.json';
import deleteConsentMock from '../assets/mock/deleteConsents.json';

class UserService {

  public static async generateOtp(phoneNumber: string): Promise<GenerateOtpResponse> {
    PersistenceService.reset();
    const fetched = await fetch(URLS.GENERATE_OTP,
      {method: 'POST', headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({phoneNumber})});
    const response = await fetched.json();

    if (response.code === 0) {
      PersistenceService.storePhoneNumber(phoneNumber);
      PersistenceService.storeRequestId(response.requestId);
    }
    return response;
  }

  public static async verifyOtp(otp: string): Promise<VerifyOtpResponse> {
    const fetched = await fetch(URLS.VERIFY_OTP,
      {method: 'POST', headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({otp, requestId: PersistenceService.getRequestId(), phoneNumber: PersistenceService.getPhoneNumber()})});
    const response = await fetched.json();
    if (fetched.status === 401) {
      PersistenceService.reset();
    }
    if (response.code === 0) {
      PersistenceService.storeToken(response.token);
    }
    return response;
  }

  public static async getConsents(): Promise<GetConsentsResponse> {
    const fetched = await fetch(URLS.GET_CONSENTS,
      {method: 'POST', headers: {
        'Authorization': `Bearer ${PersistenceService.getToken()}`,
        'Content-Type': 'application/json'
        },
        body: JSON.stringify({phoneNumber: PersistenceService.getPhoneNumber()})});
    if (fetched.status === 401) {
      PersistenceService.reset();
    }
    return await fetched.json();
  }

  public static async updateConsents(request: UpdateConsentsRequest): Promise<UpdateConsentsResponse> {
    const fetched = await fetch(URLS.UPDATE_CONSENTS,
      {method: 'POST', headers: {
        'Authorization': `Bearer ${PersistenceService.getToken()}`,
        'Content-Type': 'application/json'
        },
        body: JSON.stringify(request)});
    if (fetched.status === 401) {
      PersistenceService.reset();
    }
    return await fetched.json();
  }

  public static async deleteConsents(): Promise<DeleteConsentsResponse> {
    const fetched = await fetch(URLS.DELETE_CONSENTS,
      {method: 'DELETE', headers: {
        'Authorization': `Bearer ${PersistenceService.getToken()}`,
        'Content-Type': 'application/json'
        },
        body: JSON.stringify({phoneNumber: PersistenceService.getPhoneNumber()})});
    if (fetched.status === 401) {
      PersistenceService.reset();
    }
    return await fetched.json();
  }

  public static enableMock(): void {
    fetchMock.mock({
      matcher: URLS.GENERATE_OTP,
      method: 'POST',
      response: {
        status: 200,
        body: generateOTPMock
      }
    });
    fetchMock.mock({
      matcher: URLS.VERIFY_OTP,
      method: 'POST',
      response: {
        status: 200,
        body: verifyOTPMock
      }
    });
    fetchMock.mock({
      matcher: URLS.GET_CONSENTS,
      method: 'POST',
      response: {
        status: 200,
        body: getConsentMock
      }
    });
    fetchMock.mock({
      matcher: URLS.UPDATE_CONSENTS,
      method: 'POST',
      response: {
        status: 200,
        body: deleteConsentMock
      }
    });
    fetchMock.mock({
      matcher: URLS.DELETE_CONSENTS,
      method: 'POST',
      response: {
        status: 200,
        body: deleteConsentMock
      }
    });
  }

}

export default UserService;
